import {
  ExpressMenusApiExpressMenusCreateRequest,
  ExpressMenusApiExpressMenusPartialUpdateRequest,
  ExpressMenusApiExpressMenusUpdateRequest,
  ExpressMenusApiFactory,
  ProductApiExpressMenusListRequest,
  ProductApiFactory,
  UnifiedExpressProductMenu,
} from '@/clients/unifiedApi';
import { getUnifiedApi } from '@/services/api/unifiedApi';

export const getExpressMenusList = async (params: ProductApiExpressMenusListRequest) => {
  const api = await getUnifiedApi(ProductApiFactory);
  const results = await api.expressMenusList(params);

  // TODO: Verify with the BE why the function is returning void instead of the expected data type
  return results.data as unknown as UnifiedExpressProductMenu[];
};

export const createExpressMenu = async (data: ExpressMenusApiExpressMenusCreateRequest) => {
  const api = await getUnifiedApi(ExpressMenusApiFactory);

  const results = await api.expressMenusCreate(data);

  return results.data;
};

export const updateExpressMenu = async (data: ExpressMenusApiExpressMenusUpdateRequest) => {
  const api = await getUnifiedApi(ExpressMenusApiFactory);

  const results = await api.expressMenusUpdate(data);

  return results.data;
};

export const partialUpdateExpressMenu = async (data: ExpressMenusApiExpressMenusPartialUpdateRequest) => {
  const api = await getUnifiedApi(ExpressMenusApiFactory);

  const results = await api.expressMenusPartialUpdate(data);

  return results.data;
};
